
export const translateMeetingType = ($filter, meetingTypeStr) => {
  const meetingTypeMap = {
    'Annual General Meeting': 'label_annualGeneralMeeting',
    'Extraordinary Meeting': 'label_extraOrdinaryGeneralMeeting',
    'Court Meeting': 'label_courtMeeting',
    'General Meeting': 'label_ordinaryGeneralMeeting',
  };

  const translationKey = meetingTypeMap[meetingTypeStr];
  return translationKey ? $filter('translate')(translationKey) : meetingTypeStr; // fallback if no translation found
};

export const translateParticipationMethod = ($filter, pm) => {
  if (pm === 'EVOT') {
    return $filter('translate')('label_voteByCorrespondence');
  } else if (pm === 'PRXY') {
    return $filter('translate')('label_voteByProxy');
  } else {
    return pm;
  }
};
